<template>
  <div class="ui-confirm-popup-component-wrapper">
    <div class="ui-confirm-popup-component">
      <div class="confirm-popup-header" v-text="title" />
      <div
        class="confirm-popup-body"
        :class="{ 'content-scrollable': isScrollable }"
        v-text="message"
      />
      <div class="confirm-popup-footer">
        <button
          type="button"
          v-if="cancelText !== ''"
          class="confirm-popup-cancel-button"
          @click="sendEvent(false)"
          v-text="cancelText"
        />
        <button
          type="button"
          class="confirm-popup-confirm-button"
          @click="sendEvent(true)"
          v-text="confirmText"
          :class="styles"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import type { IConfirm } from '@/types/Components/Popup'
  import { computed } from 'vue'
  const {
    title,
    message,
    confirmText,
    cancelText,
    isScrollable,
    type = 'success',
    width = '400px',
  } = defineProps<IConfirm>()

  const emit = defineEmits(['response'])

  const sendEvent = (event: boolean) => {
    emit('response', event)
  }

  const styles = computed(() => {
    return `type-${type}`
  })
</script>

<style lang="scss">
  .ui-confirm-popup-component-wrapper {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 9999;
    display: flex;
    justify-content: center;
    align-items: center;
    .ui-confirm-popup-component {
      width: v-bind(width);
      background-color: #fff;
      border-radius: 5px;
      .confirm-popup-header {
        width: 100%;
        height: 3rem;
        padding: 0 0.5rem;
        background-color: #f7f7f7;
        display: flex;
        align-items: center;
        border-radius: 5px 5px 0 0;
        font-weight: 600;
        font-size: 1.25rem;
        color: $primary-text-color;
      }
      .confirm-popup-body {
        padding: 1rem;

        &.content-scrollable {
          max-height: 60vh;
          overflow-y: auto;
          white-space: pre;
        }
      }
      .confirm-popup-footer {
        width: 100%;
        height: 3rem;
        padding: 0 0.5rem;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        border-radius: 0 0 5px 5px;
        border-top: 1px solid $border-color;
        animation: fadeIn 0.25s ease-in-out forwards;
        @keyframes fadeIn {
          0% {
            opacity: 0;
          }
          100% {
            opacity: 1;
          }
        }
        .confirm-popup-cancel-button {
          background-color: $cancel;
          color: $primary-text-color;
          border: none;
          padding: calc(0.5em - 1px) 1em;

          border-radius: 5px;
          margin-right: 10px;
          cursor: pointer;
        }
        .confirm-popup-confirm-button {
          background-color: $success;
          color: $white;
          outline: none;
          border: none;
          padding: calc(0.5em - 1px) 1em;

          border-radius: 5px;
          cursor: pointer;
        }
      }
    }
  }
</style>
